import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { CityModel, locationAdressEntity, locationCityEntity, LocationModel, locationPlanEntity, Locations, LocationsEntity, PlanModel } from "src/app/location/location";
import { Subscription } from "rxjs";
import { MatDialog, MatSnackBar } from "@angular/material";
import { LocationService } from "../../../location/location.service";
import { AuthService } from "src/app/auth.service";
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { faCamera, faClipboard, faEdit, faEnvelope, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
@Component({
  selector: "app-locations",
  templateUrl: "./locations.component.html",
  styleUrls: ["./locations.component.css"],
})

export class UnusedLocationComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('searchAddress', { static: true })
  searchAddress?: ElementRef;
  @ViewChild('searchSubDivision', { static: true })
  searchSubDivision?: ElementRef;
  @ViewChild('searchCities', { static: true })
  searchCities?: ElementRef;

  @ViewChild('searchPlan', { static: true })
  searchPlan?: ElementRef;
  @ViewChild(MatSort) sort: MatSort;


  private subscription$ = new Subscription();
  showLoader: boolean = false;
  contractor_id: number;

  locations: LocationsEntity[] = []


  selectedAddress: LocationModel[] = []
  selectedSubDivision: LocationModel[] = []
  selectCities: CityModel[] = [];
  selectPlans: PlanModel[] = [];

  selectedlocation: LocationsEntity[] = [];
  selectedCities: LocationsEntity[] = [];
  selectedPlans: LocationsEntity[] = [];

  street_address: string | number | any | null;
  searchSubDivisionName: string | number | any | null;
  searchCity: string | number | any | null;
  searchPlans: string | number | any | null;

  faedit = faEdit;
  fatrash = faTrashAlt;
  faenvelope = faEnvelope;
  faclipboard = faClipboard;
  facamera = faCamera;

  displayedColumns = ['Action','Subdivision', 'Lot', 'Address', 'City', 'plan_name'];
  dataSource: any;

  constructor(
    private locationService: LocationService,
    public dialog: MatDialog,
    private _liveAnnouncer: LiveAnnouncer,
    private snackBar: MatSnackBar,
    private el: ElementRef
  ) {
  }
  ngAfterViewInit() {
    // this.dataSource.sort = this.sort;
  }
  ngOnInit(): void {
    this.getLocationsList();
    this.getAddress();
    this.getSubDivision();
    this.getCity();
    this.getPlans();

  }

  getSubDivision() {
    this.showLoader = true;
    this.subscription$.add(
      this.locationService.filterSubDivision(this.searchSubDivision.nativeElement).subscribe((result: locationAdressEntity) => {
        this.selectedSubDivision = result.Location
        this.showLoader = false;
      },
      (error) => {
        this.showLoader = false;
        this.snackBar.open(`Error in Getting SubDivision List `, "", {
          duration: 2000,
        });
      })
    )
  }


  getAddress() {

    this.subscription$.add(
      this.locationService.filterAddress(this.searchAddress.nativeElement).subscribe((result: locationAdressEntity) => {
        this.selectedAddress = result.Location

      })
    )
  }

  getCity() {

    this.subscription$.add(
      this.locationService.filterCity(this.searchCities.nativeElement).subscribe((result: locationCityEntity) => {
        this.selectCities = result.city

      })
    )
  }
  getPlans() {

    this.subscription$.add(
      this.locationService.filterPlan(this.searchPlan.nativeElement).subscribe((result: locationPlanEntity) => {
        this.selectPlans = result.Plans

      })
    )
  }


  onAddressSelection(address) {
    if(address){
      this.showLoader = true;
      this.subscription$.add(
        this.locationService.getAllAddress(address.street_address).subscribe(
          (result: LocationsEntity[]) => {
            this.selectedlocation = result;
            this.dataSource = new MatTableDataSource(this.selectedlocation);
            this.showLoader = false;
          },
          (error) => {
            this.showLoader = false;
            this.snackBar.open(`Error in Getting Design List `, "", {
              duration: 2000,
            });
          }
        )
      );
    }else{
      this.getLocationsList();
    }

  }

  onSubDivisionSelection(selected) {
    if(selected){
      this.showLoader = true;
      this.subscription$.add(
        this.locationService.getAllSubDivisionName(selected.subdivision_name).subscribe(
          (result: LocationsEntity[]) => {
            this.selectedlocation = result;
            this.dataSource = new MatTableDataSource(this.selectedlocation);
            this.showLoader = false;
          },
          (error) => {
            this.showLoader = false;
            this.snackBar.open(`Error in Getting Design List `, "", {
              duration: 2000,
            });
          }
        )
      );
    }else{
      this.getLocationsList();
    }

  }


  onCitySelection(selected) {
    if(selected){
      this.showLoader = true;
      this.subscription$.add(
        this.locationService.getAllCities(selected.city).subscribe(
          (result: Locations) => {
            this.selectedCities = result.Locations;
            this.dataSource = new MatTableDataSource(this.selectedCities);
            this.showLoader = false;
          },
          (error) => {
            this.showLoader = false;
            this.snackBar.open(`Error in Getting Design List `, "", {
              duration: 2000,
            });
          }
        )
      );
    }else{
      this.getLocationsList();
    }

  }

  onPlanSelection(selected) {
    if(selected){
      this.showLoader = true;
      this.subscription$.add(
        this.locationService.getAllPlans(selected.plan_name).subscribe(
          (result: Locations) => {
            this.selectedPlans = result.Locations;
            this.dataSource = new MatTableDataSource(this.selectedPlans);
            this.showLoader = false;
          },
          (error) => {
            this.showLoader = false;
            this.snackBar.open(`Error in Getting Design List `, "", {
              duration: 2000,
            });
          }
        )
      );
    }else{
      this.getLocationsList();
    }
  }


  displaySelectedAddress(subject: LocationModel) {
    return subject?.street_address
  }

  displaySelectedSubdivision(subject: LocationModel) {
    return subject?.subdivision_name
  }
  displaySelectedCity(subject: CityModel) {
    return subject?.city
  }

  displaySelectedPlan(subject: PlanModel) {
    return subject?.plan_name
  }


  /**
 * Get Locations List
 */
  getLocationsList() {
    this.showLoader = true;
    this.subscription$.add(
      this.locationService.getLocations().subscribe(
        (result: Locations) => {
          this.locations = result.Locations;
          this.dataSource = new MatTableDataSource(this.locations);
          this.showLoader = false;
        },
        (error) => {
          this.showLoader = false;
          this.snackBar.open(`Error in Getting Design List `, "", {
            duration: 2000,
          });
        }
      )
    );
  }


    /**
 * Get Locations List
 */
     viewAllLocations() {
      this.showLoader = true;
      this.subscription$.add(
        this.locationService.viewAllLocations().subscribe(
          (result: Locations) => {
            this.locations = result.Locations;
            this.dataSource = new MatTableDataSource(this.locations);
            this.showLoader = false;
          },
          (error) => {
            this.showLoader = false;
            this.snackBar.open(`Error in Getting Design List `, "", {
              duration: 2000,
            });
          }
        )
      );
    }



    parseCSVimporter(files){
      let reader = new FileReader();

      let content : any;

      reader.onload = function(){
        // const filecontent = reader.result;
        content = reader.result;
        let postJSON = {
          file : content
        }

      }

      reader.readAsText(files);

 }

 openInstrModal(){
 }

  /** Announce the change in sort state for assistive technology. */
  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }
/**
 * unsubscribe the subscriptions
 */
  ngOnDestroy() {
    this.subscription$.unsubscribe();
  }
}
